import Testimonial1 from "../../../../resources/test1.png";
import Testimonial2 from "../../../../resources/test2.png";
import Testimonial3 from "../../../../resources/test3.png";
import Testimonial4 from "../../../../resources/test4.png";

export const TestimonialsList=[Testimonial1,Testimonial2,Testimonial3,Testimonial4];